import { render } from "./MultimediaListView.vue?vue&type=template&id=06da92f6&scoped=true&ts=true"
import script from "./MultimediaListView.vue?vue&type=script&lang=ts"
export * from "./MultimediaListView.vue?vue&type=script&lang=ts"

import "./MultimediaListView.vue?vue&type=style&index=0&id=06da92f6&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06da92f6"]])

export default __exports__